import React, { useState } from 'react';
import { Instruction } from '../../../hooks/use-form-fields';
import useLinkedRecords, { LinkedRecordData } from '../../../hooks/use-linked-records';
import LinkedTaskEditor from './linked-task-editor';
import LinkedTaskRecordView from './linked-task-record-view';
import tasksOnlyFilter from './tasks-only-filter';

interface Props {
  recordId: string
  specialInstructions?: Instruction[];
}

function LinkedTaskRecords(props: Props) {
  const { recordId, specialInstructions } = props;
  const { data } = useLinkedRecords({ recordId, options: { excludeLinkedTo: true } });
  const tasks = tasksOnlyFilter(data?.linkedFrom || []);

  const [currentTask, setCurrentTask] = useState< LinkedRecordData | null>(null);

  const onView = (linkedRecordData: LinkedRecordData) => {
    setCurrentTask(linkedRecordData);
  };

  const onClose = () => (
    setCurrentTask(null)
  );

  if (tasks.length > 0) {
    return (
      <>
        { currentTask
          && (
            <LinkedTaskEditor
              recordId={currentTask.recordId}
              formId={currentTask.formId}
              linkedFieldKey={currentTask.linkedFieldKey}
              onClose={onClose}
            />
          )}
        <LinkedTaskRecordView
          linkedRecords={tasks}
          onView={onView}
          specialInstructions={specialInstructions}
        />
      </>
    );
  }

  return <></>;
}

export default LinkedTaskRecords;
